(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/gameguide/assets/javascripts/react-gameguide.js') >= 0) return;  svs.modules.push('/components/components/gameguide/assets/javascripts/react-gameguide.js');
"use strict";


(function (svs, React) {
  'use strict';

  const log = new svs.core.log.Logger('components:react-gameguide');
  const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client');
  class Gameguide extends React.Component {
    componentDidMount() {
      const gameGuides = this.props.gameGuides;
      const urls = [];
      const spelGuider = [];
      let i;

      if (useLegacyJupiterApi) {
        for (i = 0; i < gameGuides.length; i++) {
          urls.push(new svs.content.shared.ContentUrlBuilder("/id/".concat(gameGuides[i].article)).build());
        }
        const url = "/multifetch?urls=".concat(encodeURIComponent(urls.join('|')));
        svs.core.jupiter.get(url, response => {
          if (!response.error) {
            for (i = 0; i < response.responses.length; i++) {
              if (response.responses[i].error) {
                log.error('Error fetching spelguide article', response.responses[i].error);
              } else if (!response.responses[i].result && !response.responses[i].result.length) {
                log.error('Spelguide article not found', response.responses[i]);
              } else if (response.responses[i].result[0]) {
                spelGuider.push(response.responses[i].result[0]);
              }
            }
            if (this.wasClosed) {
              return;
            }
            this.showGameGuideModal(spelGuider);
          }
        });
        return;
      }

      const client = svs.content.shared.getCmsClient();
      const ids = gameGuides.map(g => g.article).join(',');
      client.v1.content.getByIds({
        ids
      }).then(response => {
        if (this.wasClosed) {
          return;
        }
        if (response && response.result) {
          for (let j = 0; j < response.result.length; j++) {
            spelGuider.push(response.result[j]);
          }
        }
        this.showGameGuideModal(spelGuider);
      }).catch(err => {
        log.error('Error fetching spelguide articles', err);
      });
    }
    componentWillUnmount() {
      this.wasClosed = true;
    }
    showGameGuideModal(spelGuider) {
      svs.content.simple_article.contentLoader.prepareArticles(spelGuider, {}, (err, preparedSpelGuider) => {
        svs.components.Modal.show(svs.components.gameguide.GameGuideView, {
          tabViews: preparedSpelGuider
        }, {
          title: 'Spelguide',
          headerClass: this.props.modalHeaderClass,
          onHideByBrowserBack: this.props.closeSpelguide,
          dontPushModalToHistory: !svs.core.detect.formfactor.mobile(),
          leftButton: {
            text: 'Stäng',
            visible: true,
            cssClass: 'btn-transparent-inverted',
            callback: () => {
              this.props.closeSpelguide();
              return true;
            }
          },
          doubleWidth: !svs.core.detect.formfactor.mobile(),
          rightButton: {
            visible: false
          }
        });
      });
    }
    updateOnTabChanged() {
      svs.events.publish('modalContentResize');
    }
    render() {
      return null;
    }
  }
  Gameguide.defaultProps = {
    modalHeaderClass: ''
  };
  svs.components.gameguide.ReactGameguide = Gameguide;
})(svs, React);

 })(window);